<template>
  <Form @submit="$emit('submit', formData)">
    <LoadingSpinner v-if="loading" />
    <template v-else>
      <FormInput :name="$t('fractions.name')" v-model="formData.name" data-testid="fractions-form__name" required />
      <FormInput
        :name="$t('fractions.translations.en')"
        v-model="formData.translations.en"
        data-testid="fractions-form__enTranslation"
        required
      />
      <FormInput
        :name="$t('fractions.translations.de')"
        v-model="formData.translations.de"
        data-testid="fractions-form__deTranslation"
        required
      />
      <FormSelect
        :name="avvNumberLabel()"
        v-model="formData.avvNumber"
        :options="avvOptions"
        :selectable="isSelectableAvvNumber"
        :disabled="!this.isAvvNumberEditable()"
        data-testid="fractions-form__avvNumber"
        required
      />
      <FormInput
        v-if="companyUser.company_type === 'industry'"
        :name="$t('fractions.internalId')"
        v-model="formData.internalId"
        required
      />

      <SingleCheckbox
        v-if="companyUser.company_type === 'industry'"
        v-model="formData.selectableInOrders"
        :label="$t('fractions.selectableInOrders')"
        name="selectableInOrders"
      />

      <div class="form-wrap">
        <label>{{ $t('fractions.color') }}</label>

        <div>
          <label for="coloring-automatic" style="display: inline">
            <input type="radio" id="coloring-automatic" name="coloring" value="automatic" v-model="formData.coloring" />
            {{ $t('fractions.coloring.automatic') }}
          </label>

          <label for="coloring-manual" style="display: inline; margin-left: 10px">
            <input type="radio" id="coloring-manual" name="coloring" value="manual" v-model="formData.coloring" />
            {{ $t('fractions.coloring.manual') }}
          </label>
        </div>

        <input
          type="color"
          v-show="formData.coloring == 'manual'"
          v-model="formData.color"
          style="margin-top: 10px; width: 25%; height: var(--input-height)"
        />
      </div>

      <Button type="submit">{{ editingMode ? $t('fractions.updateFraction') : $t('fractions.createFraction') }}</Button>
    </template>
  </Form>
</template>

<script>
import Button from '@/components/Button/index.vue'
import SingleCheckbox from '@/components/Form/Checkbox/SingleCheckbox.vue'
import FormInput from '@/components/Form/Input/index.vue'
import FormSelect from '@/components/Form/Select/index.vue'
import Form from '@/components/Form/index.vue'
import LoadingSpinner from '@/components/LoadingSpinner/index.vue'

import fractionsApi from '@/api/companies/fractions'

export default {
  inject: ['companyUser'],
  components: {
    Button,
    Form,
    FormInput,
    FormSelect,
    LoadingSpinner,
    SingleCheckbox,
  },
  props: {
    companyUuid: { type: String, required: true },
    fractionUuid: { type: String, default: null },
  },
  data() {
    return {
      editingMode: null,
      existingFraction: null,
      formData: {
        name: null,
        translations: {},
        avvNumber: null,
        internalId: null,
        coloring: 'automatic',
        selectableInOrders: true,
        color: '#269a6c',
      },
      avvOptions: [],
      formValid: false,
      loading: true,
    }
  },
  async created() {
    this.editingMode = !!this.fractionUuid
    if (this.editingMode) {
      this.existingFraction = await fractionsApi.get(this.companyUuid, this.fractionUuid)
      this.prefillExistingValues()
    }
    this.fetchAvvNumbers()
    this.loading = false
  },
  methods: {
    prefillExistingValues() {
      this.formData.name = this.existingFraction.name
      this.formData.translations = this.existingFraction.translations
      this.formData.avvNumber = this.existingFraction.avv_number
      this.formData.internalId = this.existingFraction.internal_id
      this.formData.selectableInOrders = this.existingFraction.selectable_in_orders

      if (this.existingFraction.color) {
        this.formData.coloring = 'manual'
        this.formData.color = this.existingFraction.color
      }
    },
    // AVV numbers that are shorter than 6 characters are only used for categorisation,
    // but should still appear for allocation purposes
    isSelectableAvvNumber(option) {
      return option.value.length > 5
    },
    avvNumberLabel() {
      if (this.isAvvNumberEditable()) {
        return this.$t('fractions.avvNumber')
      } else {
        return this.$t('fractions.avvNumberInUse')
      }
    },
    isAvvNumberEditable() {
      return this.existingFraction === null || this.existingFraction.can_be_deleted
    },
    async fetchAvvNumbers() {
      this.avvOptions = await fractionsApi.validAvvNumbers()
    },
  },
}
</script>
